<template>
  <div>
    <v-container fluid>
      <date-filter
        v-model="selectedDate"
        @changeDate="onDateChanged"
        :default-filter="'today'"
      ></date-filter>
    </v-container>
    <div style="background: #eee" class="mb-2">
      <v-container fluid>
        <v-layout>
          <v-flex class>
            <div>จำนวนข้อความคงเหลือทั้งหมด</div>
            <h2 class="display-3 primary--text font-weight-bold ma-0">
              {{ totalMessageLeft | numberFormat }}
            </h2>
          </v-flex>
          <v-flex class>
            <div>จำนวนออเดอร์ทั้งหมด</div>
            <h2 class="display-3 primary--text font-weight-bold ma-0">
              {{ totalOrder | numberFormat }}
            </h2>
          </v-flex>
          <v-flex class>
            <div>จำนวนข้อความที่ตอบแล้วทั้งหมด</div>
            <h2 class="display-3 primary--text font-weight-bold ma-0">
              {{ totalReply | numberFormat }}
            </h2>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div>
      <v-container fluid>
        <v-layout wrap>
          <v-flex xs12 sm12 md12 class="pa-2">
            <transition-group name="flip-list" tag="ul">
              <li class="mb-2" v-for="item in pages" :key="item.pageid">
                <v-card>
                  <v-card-text class="pa-0">
                    <v-layout wrap>
                      <v-flex shrink class="text-xs-center border-right pa-3">
                        <v-avatar :size="100" color="grey" :tile="true" style="border-radius: 5px">
                          <img :src="'/static/img/assets/aston/pages/' + item.pageid + '.jpg'" />
                        </v-avatar>
                        <div class="caption mt-2" style="max-width: 100px">
                          {{ pageName[item.pageid] ? pageName[item.pageid].name : '' }}
                        </div>
                      </v-flex>
                      <v-flex class="text-xs-center pa-3" style="border-right: 1px solid #eee">
                        <span>
                          <div>จำนวนออเดอร์</div>
                          <h2 class="display-3 font-weight-bold ma-1">
                            {{ item.ordercount | numberFormat }}
                          </h2>
                        </span>
                      </v-flex>
                      <v-flex
                        class="text-xs-center pa-3"
                        style="border-right: 1px solid #eee"
                        :class="{ 'green white--text': lessThan5Min(item.time) }"
                      >
                        <span>
                          <div>ตอบกลับภายใน</div>
                          <h2
                            class="display-3 font-weight-bold ma-1"
                            :class="{ 'white--text': lessThan5Min(item.time) }"
                          >
                            <span v-html="dayLeft(item.time)"></span>
                          </h2>
                        </span>
                      </v-flex>
                      <v-flex
                        class="text-xs-center pa-3 hoverTask"
                        style="border-right: 1px solid #eee"
                        :class="{ 'primary white--text': latestreplypage == item.pageid }"
                        @click="onShowCustomers(item.pageid, 'unclosetask')"
                      >
                        <span>
                          <div>จำนวนเคสคงเหลือ</div>
                          <h2
                            class="display-3 font-weight-bold ma-1"
                            :class="{ 'white--text': latestreplypage == item.pageid }"
                          >
                            {{ item.unclosetask | numberFormat }}
                          </h2>
                        </span>

                        <template v-if="item.latestreply">
                          <div
                            class="title pa-1"
                            :class="{ 'grey--text': latestreplypage != item.pageid }"
                          >
                            {{ item.latestreply | dateFormat('DD MMM YYYY HH:mm') }}
                          </div>
                        </template>
                      </v-flex>

                      <v-flex
                        class="text-xs-center pa-3 hoverTask"
                        style="border-right: 1px solid #eee"
                        :class="{ 'primary white--text': latestreplypage == item.pageid }"
                        @click="onShowCustomers(item.pageid, 'closetask')"
                      >
                        <span>
                          <div>จำนวนเคสที่ปิด</div>
                          <h2
                            class="display-3 font-weight-bold ma-1"
                            :class="{ 'white--text': latestreplypage == item.pageid }"
                          >
                            {{ item.closetask | numberFormat }}
                          </h2>
                        </span>

                        <template v-if="item.latestreply">
                          <div
                            class="title pa-1"
                            :class="{ 'grey--text': latestreplypage != item.pageid }"
                          >
                            {{ item.latestreply | dateFormat('DD MMM YYYY HH:mm') }}
                          </div>
                        </template>
                      </v-flex>

                      <v-flex class="text-xs-center pa-3" style="border-right: 1px solid #eee">
                        <span>
                          <div>จำนวนคนสนใจ</div>
                          <h2 class="display-3 font-weight-bold ma-1">
                            {{ item.interested | numberFormat }}
                          </h2>
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </li>
            </transition-group>
          </v-flex>
        </v-layout>
      </v-container>

      <v-dialog v-model="showCustomers" scrollable max-width="1200">
        <v-card>
          <v-card-title>Customers</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px" class="ma-0 pa-0">
            <v-layout wrap fill-height>
              <v-flex xs3 style="border-right: 1px solid #eee">
                <div
                  v-for="(group, index) in customergroup"
                  :key="`${group.subject}_${index}`"
                  class="pa-1"
                >
                  <v-card
                    style="height: 100%; cursor: pointer"
                    :color="currentSubject.subject == group.subject ? 'primary' : 'white'"
                    :class="currentSubject.subject == group.subject ? 'white--text' : ''"
                    @click="onChangeCurrentGroupType(group)"
                  >
                    <v-card-text>{{ group.subject }} ({{ group[type] }})</v-card-text>
                  </v-card>
                </div>
              </v-flex>
              <v-flex v-if="type == 'unclosetask'" xs9>
                <v-list>
                  <template v-if="loadingUser">
                    <v-layout column justify-center fill-height>
                      <div class="text-xs-center">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                      </div>
                    </v-layout>
                  </template>
                  <template v-else>
                    <template v-for="(user, index) in users">
                      <v-layout wrap :key="currentPage + '_' + user.username + '_' + index">
                        <v-flex xs9 class="primary--text pa-2">{{
                          user.username.trim() ? user.username : '-'
                        }}</v-flex>
                        <v-flex xs3 class="text-xs-right">
                          <v-btn
                            v-if="user.inboxurl"
                            outline
                            color="primary"
                            fab
                            small
                            class="btn-chat"
                            @click="openPopUp('https://business.facebook.com' + user.inboxurl)"
                          >
                            <v-icon>chat</v-icon>
                          </v-btn>
                          <v-btn
                            outline
                            color="primary"
                            fab
                            small
                            @click="onDeleteCustomer(user.pageid, user.userid)"
                            :loading="loadingDeleteUser == user.userid"
                          >
                            <v-icon>close</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      <v-divider
                        :key="currentPage + '_' + user.username + '_' + index + '_line'"
                        v-if="index != users.length - 1"
                      ></v-divider>
                    </template>
                  </template>
                </v-list>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="text-xs-right">
            <v-spacer></v-spacer>
            <v-btn color="grey" outline @click="showCustomers = false">Close</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showCloseCustomers" scrollable max-width="600">
        <v-card>
          <v-card-title>Close Customers</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px" class="ma-0 pa-0">
            <div
              v-for="(group, index) in customergroup"
              :key="`${group.subject}_${index}`"
              class="pa-1"
            >
              <v-card style="height: 100%">
                <v-card-text>{{ group.subject }} ({{ group.closetask }})</v-card-text>
              </v-card>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="text-xs-right">
            <v-spacer></v-spacer>
            <v-btn color="grey" outline @click="showCloseCustomers = false">Close</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import DateFilter from './DateFilter'

export default {
  data: function () {
    return {
      type: '',
      latestreplypage: null,
      totalReply: 0,
      totalMessageLeft: 0,
      totalOrder: 0,
      showCustomers: false,
      loadingUser: true,
      loadingDeleteUser: null,

      pages: [],
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      pageName: {
        115245059851835: { name: 'DIT1' },
        103782414379044: { name: 'DENGOTH' },
        104620487627501: { name: 'AIT3' },
        110883070374655: { name: '0xSupport' },
        101788984628392: { name: 'AIT2' },
        114106830003988: { name: 'AIT1' }
      },
      refreshInterval: undefined,

      users: [],
      currentPage: '',
      customergroup: [],
      currentSubject: '',
      showCloseCustomers: false
    }
  },
  components: {
    DateFilter
  },
  mounted: function () {
    var vm = this
    vm.getAstonAdminTasks()
    if (
      // only reset for today
      (vm.selectedDate.start == moment().format('YYYY-MM-DD'),
      vm.selectedDate.end == moment().format('YYYY-MM-DD'))
    ) {
      vm.refreshInterval = setInterval(function () {
        vm.getAstonAdminTasks()
      }, 10000)
    }
  },
  methods: {
    openPopUp(url) {
      window.open(
        url,
        '_blank',
        'toolbar=yes,scrollbars=yes,resizable=yes,top=0,width=1000,height=900'
      )
    },
    onChangeCurrentGroupType(group) {
      var vm = this
      vm.currentSubject = group
      vm.loadingUser = true
      vm.getAstonAdminUserDetails(vm.currentPage, vm.currentSubject.subject).then(function (users) {
        vm.users = users
        vm.loadingUser = false
      })
    },
    onShowCloseCustomers: function (pageid) {
      var vm = this
      vm.showCloseCustomers = true
      vm.loadingUser = true
      vm.currentPage = pageid
      vm.getAstonAdminUserUserGroupByWord(pageid).then(function (group) {
        vm.customergroup = group
        vm.currentSubject = group.length > 0 ? group[0] : null

        vm.loadingUser = false
      })
    },
    onShowCustomers: function (pageid, type) {
      var vm = this
      vm.type = type
      vm.showCustomers = true
      vm.loadingUser = true
      vm.currentPage = pageid
      vm.getAstonAdminUserUserGroupByWord(pageid).then(function (group) {
        vm.customergroup = group
        vm.currentSubject = group.length > 0 ? group[0] : null
        vm.getAstonAdminUserDetails(pageid, vm.currentSubject.subject).then(function (users) {
          vm.users = users
          vm.loadingUser = false
        })
      })
    },
    getAstonAdminUserUserGroupByWord: function (pageid) {
      let vm = this
      var data = {
        datefrom: moment(vm.selectedDate.start).format('YYYY/MM/DD'),
        dateto: moment(vm.selectedDate.end).format('YYYY/MM/DD'),
        pageid: pageid
      }
      return new Promise((resolve, reject) => {
        api.getAstonAdminUserUserGroupByWord(data, function (error, response) {
          if (error) {
            console.error(error)
            reject()
          }
          if (response.data) {
            resolve(response.data)
          } else {
            resolve([])
          }
        })
      })
    },
    getAstonAdminUserDetails: function (pageid, subject) {
      let vm = this
      var data = {
        datefrom: moment(vm.selectedDate.start).format('YYYY/MM/DD'),
        dateto: moment(vm.selectedDate.end).format('YYYY/MM/DD'),
        pageid: pageid
      }
      if (subject) {
        data.subject = subject
      }
      return new Promise((resolve, reject) => {
        api.getAstonAdminUserDetails(data, function (error, response) {
          if (error) {
            console.error(error)
            reject()
          }
          if (response.data) {
            resolve(response.data)
          } else {
            resolve([])
          }
        })
      })
    },
    getAstonAdminTasks: function () {
      let vm = this
      var data = {
        datefrom: moment(vm.selectedDate.start).format('YYYY/MM/DD'),
        dateto: moment(vm.selectedDate.end).format('YYYY/MM/DD')
      }
      return new Promise((resolve, reject) => {
        api.getAstonAdminTasksLine(data, function (error, response) {
          if (error) {
            console.error(error)
            reject()
          }
          var totalReply = 0
          var totalMessageLeft = 0
          var totalOrder = 0
          if (response.data) {
            var pages = []
            var latestPage = []
            if (response.data.length > 0) {
              var bidogoo = null
              response.data.map(function (page) {
                var p = page

                p.time =
                  parseInt(p.closetask) > 0 ? (p.timereply / parseInt(p.closetask)).toFixed(0) : 0

                totalReply += parseInt(p.closetask)

                //bidogoo
                if (p.pageid != '701617826905112') {
                  totalMessageLeft += parseInt(p.unclosetask)
                }
                totalOrder += parseInt(p.ordercount)

                // workingList.push(p)
                if (p.pageid == '701617826905112') {
                  bidogoo = p
                } else {
                  pages.push(p)
                }
                latestPage.push(p)
              })
              if (bidogoo != null) {
                pages.push(bidogoo)
              }

              latestPage.sort(function (a, b) {
                if (moment(a.latestreply).isBefore(moment(b.latestreply))) {
                  return -1
                } else if (moment(b.latestreply).isBefore(moment(a.latestreply))) {
                  return 1
                } else {
                  return 0
                }
              })

              vm.latestreplypage = latestPage[0].pageid

              vm.pages = pages
            }
          }
          vm.totalReply = totalReply
          vm.totalMessageLeft = totalMessageLeft
          vm.totalOrder = totalOrder
          resolve()
        })
      })
    },
    dayLeft: function (second) {
      var duration = moment.duration(parseInt(second), 'seconds')
      var time = ''
      // if (duration.days() > 0) {
      //   time = duration.days()
      //   time += ' <div class="headline font-weight-bold">' + this.$t('Days') + '</div>'
      // } else if (duration.hours() > 0) {
      //   time = duration.hours()
      //   time += ' <div class="headline font-weight-bold">' + this.$t('Hours') + '</div>'
      // } else
      if (duration.minutes() > 0) {
        time = duration.minutes()
        time += ' <div class="headline font-weight-bold">' + this.$t('Minutes') + '</div>'
      } else {
        time = duration.seconds()
        time += ' <div class="headline font-weight-bold">' + this.$t('Seconds') + '</div>'
      }
      return time
    },
    lessThan5Min: function (second) {
      var duration = moment.duration(parseInt(second), 'seconds')
      return duration.minutes() <= 5
    },
    onDeleteCustomer: function (pageid, userid) {
      let vm = this
      var data = {
        pageid: pageid,
        userid: userid
      }
      return new Promise((resolve, reject) => {
        vm.loadingDeleteUser = userid
        api.saveAstonUpdateAdminTasks(data, function (error, response) {
          if (error) {
            console.error(error)
            reject()
          }
          if (response.data) {
            var userIndex = vm.users.findIndex(function (el) {
              return el.userid == userid
            })

            if (userIndex > -1) {
              vm.users.splice(userIndex, 1)
            }
            vm.loadingDeleteUser = null
          }
          resolve()
        })
      })
    },
    onDateChanged(value) {
      clearInterval(this.refreshInterval)
      var vm = this
      vm.getAstonAdminTasks()
      if (value == 'today') {
        if (
          // only reset for today
          (vm.selectedDate.start == moment().format('YYYY-MM-DD'),
          vm.selectedDate.end == moment().format('YYYY-MM-DD'))
        ) {
          vm.refreshInterval = setInterval(function () {
            vm.getAstonAdminTasks()
          }, 10000)
        }
      }
    }
  },
  beforeDestroy: function () {
    clearInterval(this.refreshInterval)
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
.flip-list-move {
  transition: transform 1s;
}
@media only screen and (min-width: 600px) {
  .border-right {
    border-right: 1px solid #eee;
  }
}

.btn-chat i {
  display: inherit;
}

.hoverTask {
  cursor: pointer;
  transition: 0.4s ease;
}
.hoverTask:hover {
  background-color: #ff4c49 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/dashboard/AstonLineDashboard.vue